/**
 *@author shaolei
 *@date 2020/04/13
 *@file_name:notAuto
 *@Description:未认证
 */
<template>
  <div class='autoDefault'>
    <div class="table">
      <div class="tr">
        <div class="th">公司名称：</div>
        <div class="td">{{ companyInfo.companyName ? companyInfo.companyName : '暂无'}}</div>
      </div>
      <div class="tr">
        <div class="th">公司地址：</div>
        <div class="td">{{ companyInfo.companyDetailAddr ? companyInfo.companyProvince + "/" + companyInfo.companyCity + "/" + companyInfo.companyCounty + "  " + companyInfo.companyDetailAddr : '暂无'}}</div>
      </div>
      <div class="tr">
        <div class="th">所属行业：</div>
        <div class="td">{{ companyInfo.industry ? companyInfo.industry : '暂无'}}</div>
      </div>
      <div class="tr">
        <div class="th">统一社会信用代码：</div>
        <div class="td">{{ companyInfo.creditUnionCode | desensitization}}</div>
      </div>
      <div class="tr textarea">
        <div class="th">三件合一证件：</div>
        <div class="td">
          <div class="p" v-if="!companyInfo.cardImg">暂无</div>
          <div @mouseenter="isMask = true" @mouseleave="isMask = false" class="img" v-show="companyInfo.cardImg">
            <img class="_img" id="companyImg" :src="barcodeUrl" alt="">
            <div v-show="isMask" @click="previewImg()" class="mask">
              <img src="@/assets/images/zoom.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="auth != 2" @click="toAuth()" class="btn">
      <span v-if="auth == 0">去认证</span>
      <span v-if="auth != 0">重新认证</span>
    </div>
    <div v-else @click="tosubscribe()" class="btn">
      <span>去订阅接口</span>
    </div>
    <el-dialog :visible.sync="isPreviewImg" width="60%" center>
      <div class="previewImg">
        <img :src="barcodeUrl" alt="">
      </div>
    </el-dialog>
  </div>
</template>
<script>
import uitls from "@/utils/utils";
export default {
  name:'notAuto',
  data () {
    return {
      isPreviewImg:false,
      isMask:false,
      imgSrc:'https://static.runoob.com/images/demo/demo4.jpg',
      companyInfo:{},
      auth:0,
      barcodeUrl:''
    };
  },

  components: {
    //组件声明
  },

  computed: {
    //计算属性
  },

  created(){
    //创建时执行
    this.init()
  },

  mounted(){
    //数据挂载
    if(this.companyInfo.cardImg){
      this.getBarcode();
    }
  },
  filters:{
    desensitization(data){
     if(data){
        
        const len = data.length;
        let leftStr = data.substring(0,10);
        let rightStr = data.substring(16,len);
        let str = ''
        for (let i = 0; i <6;i++) {
                str = str + '*';
        }
        str = leftStr + str + rightStr;
        return str;
     }else{
        return '暂无'
     }
    },
  },
  methods: {
    //函数声明
    init(){
      this.auth = this.$parent.auth
      if(this.$parent.auth == 0){

      }else{
        this.companyInfo = this.$parent.companyInfo
      }
    },
    /** 预览图片 */
    previewImg(){
      this.isPreviewImg = true
    },
    getBarcode() {
       if(this.companyInfo.cardImg.includes("files")){
          this.$axios.get('/openapi-interface/companyImage',{
            withCredentials: true,
          }).then(res=>{
            this.barcodeUrl = res.data.data
          })
       }else{
          this.$axios.get('/openapi-interface/companyImage',
              { 
                withCredentials: true,
                  //设定接收类型为blob,头部什么的自行添加
                responseType:'blob',
              }
          ).then(res=>{
            this.barcodeUrl=URL.createObjectURL(res.data);
          })
      }
    },    
    /** 去认证 */
    toAuth(){
      this.$parent.switchComponent('companyAuth')
    },
    /** 去新增订阅 */
    tosubscribe(){
      this.$router.push({path:"/control/newApplication"})    
    },
  }
}
</script>
<style lang='less' scoped>
.autoDefault{
  padding-top: 20px;

  .table{
    border: 1px solid #EBEAE8;

    .tr{
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #EBEAE8;
      color: #333333;
      font-size: 14px;
      
      .th{
        flex-basis: 176px;
        padding-left: 20px;
        border-right: 1px solid #EBEAE8;
        background: #FAFAFA;
        box-sizing: border-box;
      }
      .td{
        flex: 1;
        padding-left: 14px;
        box-sizing: border-box;

        .img{
          width: 100px;
          height: 100px;
          padding-top: 10px;
          border-radius: 2px;
          cursor: pointer;
          position: relative;

          ._img{
            width: 100%;
            height: 100%;
            border-radius: 2px;
          }

          .mask{
            position: absolute;
            cursor: pointer;
            z-index:9;
            left: 0;
            right: 0;
            top: 10px;
            bottom: 0;
            border-radius: 2px;
            background: rgba(51,51,51,0.7);
            display: flex;
            align-items: center;
            justify-content: center;

            img{
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
    .textarea{
      height: 120px;
    }

    :last-child{
      border-bottom: none;
    }
  }

  .previewImg{
    text-align: center;

    img{
      max-height: 600px;
    }
  }

  .btn{
    width: 400px;
    height: 46px;
    margin: 0 auto;
    margin-top: 50px;
    line-height: 46px;
    text-align: center;
    color: #333333;
    font-size: 14px;
    background: #FABE00;
    border-radius: 2px;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
    cursor: pointer;
  }
}
</style>